import { render, staticRenderFns } from "./OrganisationUpdate.vue?vue&type=template&id=34a7122a&"
import script from "./OrganisationUpdate.vue?vue&type=script&lang=ts&"
export * from "./OrganisationUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports